import { useState } from 'react';

import { MoonIcon, SunIcon } from '@heroicons/react/24/outline';

export default function SplashPreview() {
  const [isDark, setIsDark] = useState(false);

  const videoSrc = isDark ? '/splash.gif' : '/splash-light.mp4';
  const isVideo = videoSrc.endsWith('.mp4');

  return (
    <div className={`fixed inset-0 z-[99999] overflow-hidden ${isDark ? 'bg-black' : 'bg-white'}`}>
      {/* Theme toggle */}
      <div className="absolute top-4 right-4 z-10">
        <button
          onClick={() => setIsDark(v => !v)}
          className="flex items-center gap-2 px-3 py-2 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 text-white text-sm font-medium"
        >
          {isDark ? <SunIcon className="h-4 w-4" /> : <MoonIcon className="h-4 w-4 text-black" />}
          <span className={isDark ? 'text-white' : 'text-black'}>
            {isDark ? 'Light mode' : 'Dark mode'}
          </span>
        </button>
      </div>

      {isVideo ? (
        <video
          key={videoSrc}
          src={videoSrc}
          autoPlay
          muted
          playsInline
          loop
          className="absolute inset-0 w-full h-full object-contain"
        />
      ) : (
        <img
          key={videoSrc}
          src={videoSrc}
          alt="Splash preview"
          className="absolute inset-0 w-full h-full object-contain"
        />
      )}
    </div>
  );
}
